export default __webpack_public_path__ + "static/media/magazines.e6222478.svg";